import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@sbd-account-portal/app/environments/environment';
import { map, Observable, of } from 'rxjs';
import { SuretyTeamResponse, AssignmentItem } from './surety-team.types';
import { MessageRecipient } from '@sbd-account-portal/app/modules/tasksets/tasksets.types';

@Injectable({providedIn: 'root'})
export class SuretyTeamWidgetService {
  private _httpClient = inject(HttpClient);

  suretyTeam = signal<any[]>(null);
  recipientList = signal<MessageRecipient[]>(null);

  constructor() {
    this.getSuretyTeam().subscribe();
  }

  getSuretyTeam(): Observable<AssignmentItem[]> {
    if(this.suretyTeam() !== null){
      return of(this.suretyTeam())
    }

    return this._httpClient.get<SuretyTeamResponse>(`${environment.apiBaseUrl}/v4/surety-team`)
      .pipe(
        map((response) => {
          if(response.data.assignments.length > 0) {
            let recipientList: MessageRecipient[] = [];
            response.data.assignments.forEach((assignment) => {
              let messageRecipient = <MessageRecipient>{};
              if(assignment.assignment_role_type === 'accountmanager') {
                messageRecipient.scope_key = 'xbadminscope'
                messageRecipient.id = assignment.assignment_admin_id
                messageRecipient.name = assignment.user_first_name + ' ' + assignment.user_last_name;
                messageRecipient.type = 'Account Manager';
                messageRecipient.type_code = 'accountmanager';
                assignment.assignment_role_type = 'Account Manager';
                assignment.assignment_role_type_code = 'accountmanager';
              }

              if(assignment.assignment_role_type === 'accountbondspecialist') {
                messageRecipient.scope_key = 'xbadminscope'
                messageRecipient.id = assignment.assignment_admin_id
                messageRecipient.name = assignment.user_first_name + ' ' + assignment.user_last_name;
                messageRecipient.type = 'Bond Specialist';
                messageRecipient.type_code = 'accountbondspecialist';
                assignment.assignment_role_type = 'Bond Specialist';
                assignment.assignment_role_type_code = 'accountbondspecialist';
              }
              recipientList.push(messageRecipient);
            });
            recipientList.push(<MessageRecipient>{scope_key: 'cipxadminuserteam', id: 4, name: 'Service', type: 'Team', type_code: 'team'});
            this.recipientList.set(recipientList);
            this.suretyTeam.set(response.data.assignments);
            return response.data.assignments;
          }
          return response.data.assignments;
        })
      )
  }
}
